// Tab switcher for the ContactPage campus locations.
export default function initContactTabs() {
    document.querySelectorAll('[data-contact-tabs]').forEach((root) => {
        const tabs = root.querySelectorAll('[data-tab-target]');
        const panels = root.querySelectorAll('.contact-locations__panel');
        if (!tabs.length || !panels.length) return;

        tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                const targetSel = tab.getAttribute('data-tab-target');
                tabs.forEach((t) => {
                    t.classList.toggle('is-active', t === tab);
                    t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
                });
                panels.forEach((panel) => {
                    const matches = '#' + panel.id === targetSel;
                    panel.classList.toggle('is-active', matches);
                    panel.setAttribute('aria-hidden', matches ? 'false' : 'true');
                });
            });
        });
    });
}
